<template>
  <div class="language-switcher-sidebar">
    <simple-list
      id="languageList"
      ref="languageList"
      :server-items="languageOptions"
      class="req"
      variant="currency-list"
      internal-scroll
      :height="listHeight"
      @item-update="$emit('update-focusable')"
      @mounted="$emit('update-focusable')"
    >
      <template #filter>
        <div
          ref="header"
          class="language-switcher-header"
        >
          <header-close :deactivate="close" />
          <div class="language-switcher-search-bar form">
            <div class="language-switcher-search-bar__input input">
              <input
                id="languageSearch"
                type="text"
                class="search-input icon-search"
                :class="[{ 'have-value': !!inputString }]"
                data-field-type="SingleLineText"
                @input="filterItems($event.currentTarget.value, 'input')"
              >
              <label
                class="floating search-label"
                for="languageSearch"
              >
                {{ tc('formFields.preferredLanguage') }}
              </label>
            </div>
          </div>
        </div>
      </template>
      <template #card-template="{ item, key }">
        <language-switcher-card
          :key="key"
          :item="item"
          :search-input="inputString"
          :query-changed="queryChanged"
        />
      </template>
    </simple-list>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import HeaderClose from '@components/04.booking/booking-widget/components/header-close/header-close.vue'
  import LanguageSwitcherCard from './language-switcher-card.vue'

  export default {
    name: 'LanguageSwitcherList',
    components: {
      HeaderClose,
      LanguageSwitcherCard
    },
    props: {
      languages: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      listHeight: null,
      inputString: '',
      inputValue: { $exists: true },
      queryChanged: -1,
      loading: true
    }),
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapState('responsive', { wHeight: 'height' }),
      ...mapState('global', { currentLang: 'lang' }),
      languageOptions() {
        return this.languages.filter((l) => (l.regionalIso || l.iso)?.toLowerCase() !== this.currentLang?.toLowerCase())
      }
    },
    watch: {
      wHeight() {
        this.calculateListHeight()
      }
    },
    mounted() {
      this.calculateListHeight()
      this.loading = false
    },
    methods: {
      close() {
        this.$emit('close')
      },
      calculateListHeight() {
        const headerHeight = this.$refs.header.clientHeight
        this.listHeight = this.wHeight - headerHeight
      },
      async filterItems(value, type) {
        if (type === 'input') {
          if (value) {
            this.inputValue = { $regex: `${value}`, $options: 'i' }
            this.inputString = value
          } else {
            this.inputValue = { $exists: true }
            this.inputString = ''
          }
        }
        const searchFilter = {
          $or: [
            { displayName: this.inputValue },
            { regionalIsoCode: this.inputValue },
            { iso: this.inputValue }
          ]
        }
        await this.$refs.languageList.updateFilter(searchFilter)
        this.queryChanged += 1
      }
    }
  }
</script>
